import Helmet from "react-helmet"

const SCRIPT_REGEX = /\<script.*?\<\/script\>/g
const SRC_REGEX = /src\=\".*?\"/g


///
// Takes a string of text and outputs the html without script tags. Uses react helmet to add script tags to the header
// of the page. Checks an array of sources on the window object called "refscriptlist" to make sure scripts are not
// added multiple times.
// The key prop should help make sure the script list stays unique if this component is used multiple times on a single page.
///
function InnerHTMLWithScript({ id, text }) {
  if(!text) {
    return null
  }
  if(!window.refscriptlist) {
    window.refscriptlist = []
  }

  const scripts = text.matchAll(SCRIPT_REGEX),
        html    = text.replaceAll(SCRIPT_REGEX, "")

  const scriptList = []
  for(const match of scripts) {
    const results = SRC_REGEX.exec(match[0])
    if(results) {
      const scriptToCheck = results[0].substring(5, results[0].length-1)
      if(scriptToCheck) {
        scriptList.push(scriptToCheck)
      }
    }
  }

  return (
    <>
      <Helmet>
        {scriptList.map((scriptSrc, idx)=>{
          return (
            <script key={`${id}_${idx}`} src={scriptSrc}></script>
          )
        })}
      </Helmet>
      <div
        dangerouslySetInnerHTML={{
          __html: html
        }} />
    </>
  )
}

function areEqual(prevProps, nextProps) {
  // console.log('equal: ', prevProps.text === nextProps.text)
  return prevProps.text === nextProps.text
}
export default InnerHTMLWithScript